const mediaItems = [
  {
    title: '独家深扒：顶流明星塌房时间线全梳理',
    duration: '15:28',
    views: '89万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20themed%20studio%20scene%20with%20spotlight%20on%20empty%20chair%2C%20warm%20crimson%20and%20amber%20lighting%2C%20cinematic%20atmosphere%2C%20investigative%20journalism%20aesthetic%2C%20high%20contrast%20shadows%2C%20mysterious%20mood%2C%20editorial%20photography%20style&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    title: '网红圈潜规则：MCN机构如何操控舆论',
    duration: '22:10',
    views: '67万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20layered%20screens%20and%20digital%20patterns%20in%20warm%20red%20and%20gold%20tones%2C%20modern%20media%20control%20room%20aesthetic%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20cinematic%20color%20grading%2C%20investigative%20theme&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    title: '那些年被封杀的明星：内幕全记录',
    duration: '18:45',
    views: '55万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20atmosphere%20with%20silhouettes%20and%20dramatic%20backlighting%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20abstract%20texture%20layers%20suggesting%20hidden%20stories%2C%20editorial%20photography%20with%20cinematic%20mood%2C%20dark%20elegant%20background&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    title: '娱乐圈资本局：谁在幕后操控流量明星',
    duration: '30:02',
    views: '43万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20financial%20district%20with%20warm%20dramatic%20lighting%2C%20blurred%20motion%20effects%2C%20crimson%20and%20gold%20color%20palette%2C%20mysterious%20corporate%20aesthetic%2C%20high%20contrast%20shadows%2C%20cinematic%20atmosphere%2C%20dark%20sophisticated%20mood&width=640&height=360&seq=media-04&orientation=landscape',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1100px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          猛料视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          深度解析黑料事件，视频版吃瓜更过瘾
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mediaItems.map((item) => (
            <a
              key={item.imageUrl}
              href="#media"
              onClick={(e) => e.preventDefault()}
              className="group block bg-background-100 rounded-xl border border-secondary-200/60 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-secondary-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center bg-primary-500/90 text-background-50 rounded-full group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-lg ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-[10px] rounded">
                  {item.duration}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-700 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-1.5">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views}次播放
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}